import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import './DialogWrapper.css';

class DialogWrapper extends PureComponent {
  render() {
    const actions = [
      <Button
        className="u-mr-full"
        color="primary"
        onClick={this.props.onClickCancel}
        key="cancel"
        data-qa="qa-cancelButton"
      >
        Cancel
      </Button>,
      <Button
        variant="contained"
        color="primary"
        onClick={this.props.onClickMainAction}
        disabled={this.props.disableMainAction}
        hidden={this.props.hideMainAction}
        key="mainAction"
        data-qa="qa-mainActionButton"
      >
        {this.props.mainActionLabel}
      </Button>,
    ];

    return (
      <Dialog
        open={this.props.open}
        fullWidth={true}
        maxWidth={this.props.maxWidth}
        data-qa={this.props.qaTag}
      >
        <DialogTitle>{this.props.title}</DialogTitle>
        <DialogContent>{this.props.children}</DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}

DialogWrapper.propTypes = {
  onClickCancel: PropTypes.func.isRequired,
  onClickMainAction: PropTypes.func,
  title: PropTypes.string,
  mainActionLabel: PropTypes.string,
};

DialogWrapper.defaultProps = {
  title: 'Hello',
  mainActionLabel: 'Submit',
  disableMainAction: false,
};

export default DialogWrapper;
